export default "__VITE_ASSET__C8U1sV05__"